

/*
	Source: htdocs/wim/js/core/src/PredictiveSearch.js
*/
(function($, wimbledonCore) {
/**
     *  Poller Class
     *      Used for setting up repeating AJAX loads. Supports
     *      a variety of options ranging from simple to complex.
     */
    function PredictiveSearch() {
        var id = 'PredictiveSearch';
        var logger = new eventsCore.util.Logger(id);
        var api = new Object();

        var searchField;
        var searchDisplay;
        var loadsrc;
        var loader;
        var arrowDown = false;
        var profileBoost = 10;
        var playerDist = 0.8;
        var siteDist = 0.6;
        var inputVal = '';
        var url_pre = '';
        var url_post = '&wt=json&fl=url,htsearch,score,metatag.description&rows=10';
        var url;
        var query = "q=(((htsearch:[SEARCH_TEXT]*) OR (htsearch:[SEARCH_TEXT]~[PLAYER_DIST])) AND (url:players/overview)^[PROFILE_BOOST]) OR (title:[SEARCH_TEXT]*~[SITE_DIST]) OR (title:[SEARCH_TEXT]) OR (content:[SEARCH_TEXT])";


        /*
        //orig
        q=(htsearch:[SEARCH_TEXT]*)%5E6%20and%20(url:players/overview)ˆ2&wt=json&fl=url,htsearch,score,metatag.description&rows=10&indent=true

        //test
        q=(htsearch:+%22feder*%22%20OR%20(htsearch:+%22feder*%22%20AND%20url:%22players/overview%22))&wt=json&fl=url,htsearch,score,metatag.description&rows=10

        //new
        q=((htsearch:+"feder*")%20AND%20(url:"players/overview")%5E6)%20OR%20htsearch:+"feder*"&wt=json&fl=url,htsearch,score,metatag.description&rows=10
        q=((htsearch:+"[SEARCH_TEXT]*")%20AND%20(url:"players/overview")%5E6)%20OR%20htsearch:+"[SEARCH_TEXT]*"&wt=json&fl=url,htsearch,score,metatag.description&rows=10

        //new2
        q=((htsearch:"[SEARCH_TEXT]*%20Player%20Profile"~2)%5E100%20OR%20htsearch:[SEARCH_TEXT]*)&wt=json&fl=url,htsearch,score,metatag.description&rows=10

        q=((htsearch:fed*)%20AND%20(url:players/overview))%20OR%20(htsearch:feder*)&wt=json&fl=url,htsearch,score,metatag.description&rows=10
        */

        var hideMenu = function() {
            $(searchDisplay).hide();
        };


        var searchLoadHandler = function(data) {
            logger.info('searchLoadHandler - data:%o', data);
            var results = data.response.docs;
            var displayText;

            $(searchDisplay).html('');
            hideMenu();
            hasResults = false;

            $(searchDisplay).append('<li class="title">POPULAR RESULTS</li>');

            _.each(results, function(result, key) {
                if (result.score >= 0.0001 && result.htsearch !== undefined) {
                    //logger.info('searchLoadHandler - data:%o score:%o url:%o', result.htsearch, result.score, result.url);
                    hasResults = true;
                    displayText = highlightText(result.htsearch, inputVal, '<span class="match">', '</span>');
                    displayText = displayText.replace(/\\"/g, '"');
                    displayText = displayText.replace(/\\'/g, '\'');
                    //logger.info('searchLoadHandler - display:%o ', displayText);
                    $(searchDisplay).append('<li class="result"><a href="' + result.url + '">' + displayText + '</a></li>');
                }
            });

             $(searchDisplay).append('<li class="more"><span class="icon">&nbsp;</span><a href="/en_GB/search/results.html?query=' + inputVal + '">FOR MORE RESULTS ></a></li>');

            if (hasResults)
                $(searchDisplay).show();

           $(searchDisplay).addClass('searchDisplayList');
            //$( "#menu" ).menu();
        };

        var initKeyWatch = function() {
            $(searchField).on('paste input', function( event ) {
                inputVal = event.target.value;
                logger.info('init - value:%o last:%o', inputVal, (inputVal.substr(inputVal.length - 1) != ' '));

                if (inputVal) {
                    if (inputVal.substr(inputVal.length - 1) != ' ') {
                        var searchUrl = url + api.query(inputVal) + url_post;
                        searchUrl = encodeURI(searchUrl);
                        logger.info('init - url:%o', searchUrl);
                        loadsrc = {};
                        loadsrc[searchUrl] = searchLoadHandler;
                        loader.add(loadsrc, -1);
                    }
                }
                else {
                    $(searchDisplay).hide();
                }
            });

            $(searchField).on('keydown', function( event ) {
                return;
                if (event.which === 40) {
                    arrowDown = true;
                    $(searchField).blur();

                    logger.info('keydown - value:%o', $(searchDisplay).find('li').first());
                    $(searchDisplay).find('li').first().addClass('highlight'); 
                }
            });

            $('html').on('keydown', function( event ) {
                var children = $(searchDisplay).children();
                //logger.info('keydown - value:%o children:%o', event.which, children.length);

                //down arrow
                if (event.which === 40) {
                    if (children.length > 0){
                        arrowDown = true;
                        $(searchField).blur();
                        

                        var hl = $(searchDisplay).find('.highlight');
                        //logger.info('keydown - child%o hl:%o', $(children[0]), hl);
                        if (hl.length > 0) {
                            $(hl).removeClass('highlight');
                            if ($(hl).next().length) {
                                $(hl).next().addClass('highlight'); 
                            }
                            else {
                                $(hl).addClass('highlight');
                            }
                        }
                        else {
                           $(children[0]).addClass('highlight');  
                        }
                    }
                }

                //up arrow
                else if (event.which === 38) {
                    if (children.length > 0){
                        var hl = $(searchDisplay).find('.highlight');
                        //logger.info('keydown - child%o hl:%o', $(children[0]), hl);
                        if (hl.length > 0) {
                            $(hl).removeClass('highlight');
                            if ($(hl).prev().length) {
                                $(hl).prev().addClass('highlight'); 
                            }
                            else {
                                $(hl).addClass('highlight');
                            }
                        }
                    }
                }
            });

            $(searchField).blur(function( event ) {
                //logger.info('blur - value:%o', event.target.value);
                if (!arrowDown){
                    setTimeout(hideMenu, 200);
                }

                arrowDown = false;
            });

            $(searchField).focus(function( event ) {
                //logger.info('focus - value:%o', event.target.value);
            });
        }

        var replaceAll= function (value, search, replace, caseSensitive) {
            //return target.replace(new RegExp(search, 'g'), replacement);
            return value.split(search).join(replace);
        };

        var highlightText = function (value, term, pre, post) {
            //logger.info("highlight 1 - val:%o term:%o", value, term);
            var pos = 0;
            var vall = value.toLowerCase();
            var terml = term.toLowerCase();
            var limit = 0;

            while (pos < vall.length && limit < 5) {
                pos = vall.indexOf(terml, pos);
                if (pos > -1) {
                    //logger.info("highlight a - pos:%o", pos);
                    value = [value.slice(0, pos), pre, value.slice(pos)].join('');
                    vall = value.toLowerCase();
                    pos += terml.length + pre.length;
                    //logger.info("highlight b - pos:%o val:%o", pos, value);
                    value = [value.slice(0, pos), post, value.slice(pos)].join('');
                    vall = value.toLowerCase();
                    pos += post.length;
                    //logger.info("highlight c - pos:%o val:%o", pos, value);
                }
                else {
                    pos = vall.length + 1;
                }
                
                limit++;
            }  
            //logger.info("highlight 2 - val:%o term:%o", value, term);
            return value; 
        }

        api.init = function(on, field, display) {
            logger.info('init - field:%o enabled:%o', field, on);
            
            url = url_pre + window.slr_searchContext + 'select?';

            if (on) {
                $(document).ready(function(){
                    searchField = $('#' + field)[0];
                    searchDisplay = $('#' + display)[0];
                    $(searchDisplay).hide();
                    logger.info('init - field:%o', searchField);

                    if (searchField) {
                        loader = eventsCore.Poller('search');
                        initKeyWatch();
                    }
                });
            }
        };

        api.searchTerm = function(val) {
            logger.info('searchTerm - val:%o', val);
        };

        api.query = function(searchTerm) {
            searchTerm = searchTerm.toLowerCase();
            
            var q = replaceAll(query, "[SEARCH_TEXT]", searchTerm);
            q = replaceAll(q, "[PLAYER_DIST]", playerDist);
            q = replaceAll(q, "[PROFILE_BOOST]", profileBoost);
            q = replaceAll(q, "[SITE_DIST]", siteDist);
            return q;
        }

        return api;
    };

    wimbledonCore.predictiveSearch = new PredictiveSearch();

}(jQuery, window.wimbledonCore));
